import { useMutation } from '@tanstack/react-query'

import * as api from '../api'
import useInvalidate from '../useInvalidate'

export default function useDeleteUser() {
  const invalidate = useInvalidate()

  return useMutation({
    mutationFn: async ({ userUuid }: { userUuid: string }) => {
      await api.del(`user/${encodeURIComponent(userUuid)}`, {})
      await invalidate.users()
      await invalidate.userLearningAssignments()
      await invalidate.groups()
    },
  })
}
